import type { DeviceModel } from '../../types/deviceModel';
import { portRow, simpleLayout } from './layoutHelpers';

export const rocketPrismAcModel: DeviceModel = {
  equipmentId: 'ubnt-rocket-prism-ac',
  selfDrawWatts: 8.5,
  powerInputs: [{ id: 'poe-in', kind: 'poe-in', portNumber: 1, face: 'front' }],
  layout: {
    simple: simpleLayout(
      portRow({
        count: 1,
        startNumber: 1,
        kind: 'rj45',
        speedsMbps: [10, 100, 1000],
        poeIn: { standards: ['passive-24'], voltageMin: 20, voltageMax: 26, maxWatts: 15 },
        y: 22,
      }),
      160,
      70
    ),
  },
};
